
import en from'@24i/prd-localization-files-prj-aeroverse/dist/en.json';


export var i18nOptions={
resources:{
en:{aeroverse:en,sott:en}
},
defaultNS:'aeroverse',
ns:['aeroverse'],
react:{
useSuspense:false
},
fallbackLng:'en'
};